<template>
  <div class="fCol jCenter aCenter"
    v-bind:style="{width: w === undefined ? 'auto' : `${w}px`}">
    <div class="hint" v-if="hint !== undefined">{{hint}}</div>
    <div class="switchBtn fRow aStart"
      v-bind:class="{load: load, mini: mini}">
      <div class="line"></div>
      <div v-bind:class="{active: this.val, deactive: !this.val, monocolor: this.monocolor}"
      class="handle aCenter jCenter fRow">{{computedLabel}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['activeLabel', 'deactiveLabel', 'load', 'val', 'monocolor', 'mini', 'hint', 'w'],
  data() {
    return {
      label: '',
      enterValue: this.val,
    };
  },
  computed: {
    computedLabel() {
      let v = '';
      if (this.val) {
        v = this.activeLabel;
      } else {
        v = this.deactiveLabel;
      }
      return v;
    },
  },
  watch: {
    load() {
      // console.log('load changes: ', this.load);
    },
  },
};
</script>

<style lang='scss' scoped>
.hint {
  font-size: 10px;
  font-weight: 200;
  margin-bottom: 8px;
}
  .switchBtn{
    height: 24px;
    min-height: 24px;
    position: relative;
    min-width: 48px;
    position: relative;
    cursor: pointer;
    transition: all cubic-bezier(0.5, 0, 0, 1) 0.3s;
    transition: all cubic-bezier(0.5, 0, 0, 1) 0.3s;
    user-select: none;
    .load {
      pointer-events: none;
      opacity: 0.2 !important;
    }

     .line{
      height: 12px;
      position: absolute;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      top: 50%;
      border-radius: 64px;
      background-color: var(--shade55);
      z-index: 10;
    }
     .handle{
      padding: 0 8px;
      font-size: 12px;
      font-weight: 300;
      position: relative;
      color: var(--invertText);
      cursor: pointer;
      justify-content: center !important;
      min-width: 48px;
      border-radius: 80px;
      height: 100%;
      z-index: 20;
      transition: all cubic-bezier(0.5, 0, 0, 1) 0.3s;
    }
  }
  .switchBtn.mini {
    height: 20px;
    min-height: 16px;
    min-width: 32px;
     .line{
      height: 8px;
    }
     .handle{
      font-size: 10px;
      font-weight: 300;
      position: relative;
      color: var(--normalText);
      cursor: pointer;
      min-width: 32px;
      border-radius: 80px;
      text-align: center;
      height: 100%;
      z-index: 20;
      transition: all cubic-bezier(0.5, 0, 0, 1) 0.3s;
    }
  }

  .active{
    background-color: var(--themeGreen);
    margin: 0 8px 0 0;
    justify-content: flex-start;
  }

  .deactive{
    background-color: var(--shade5);
    margin: 0 0 0 8px;
    justify-content: flex-end;
  }
  .monocolor {
    background-color: var(--themeGreen) !important;
  }

</style>
